<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-descriptions title="" :column="1" border>
				<el-descriptions-item label="会员名称">kooriookami</el-descriptions-item>
				<el-descriptions-item label="下级会员">18100000000</el-descriptions-item>
				<el-descriptions-item label="会员售价">苏州市</el-descriptions-item>
				<el-descriptions-item label="会员图标">
					<img src="" style="width: 80px;height: 80px;border-radius: 50%;" />
				</el-descriptions-item>
			</el-descriptions>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>会员权益</h4>
			</div>
			<el-radio v-model="radio" label="1">课程折扣</el-radio>
			<div class="flex" style="margin: 20px 0;">
				<div>单章节优惠积分</div>
				<el-input style="margin: 0 10px;width: 150px;" disabled v-model="value"/>
				<div style="margin-left: 20px;">整章购买优惠积分</div>
				<el-input style="margin-left: 10px;width: 150px;" disabled v-model="value"/>
			</div>
			<el-radio v-model="radio" label="1">日常积分获取翻倍</el-radio>
			<div class="flex" style="margin-top: 20px;">
				<div>翻倍倍数</div>
				<el-input style="margin: 0 10px;width: 150px;" disabled v-model="value"/>
			</div>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			 <el-button type="primary" style="width: 200px;" plain @click="goBack">返回</el-button>
		</el-card>


	</div>
</template>

<script>
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		getUser,
		getDoubao,
		getAiApplicationHistoryList
	} from "@/api/auth"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				radio:'1',
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				value:'500'
			};
		},
		components: {
			CommonPagination,
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			this.getDoubao()
			if (uuid) {
				this._getUserListDetail(uuid);
			}
		},
		methods: {
			handlePageChange(page) {
				this.page_index = page
				this.getDoubao()
			},
			handlePageChange1(page) {
				this.page_index1 = page
				this.getAiApplicationHistoryList()
			},
			handleClick(tab, event) {
				if (tab.name == 'second') {
					this.getAiApplicationHistoryList()
				}
				if (tab.name == 'first') {
					this.getDoubao()
				}
			},
			async getDoubao() {
				let postData = {
					page_size: this.page_size,
					page_index: this.page_index,
					user_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getDoubao(postData);
				if (status !== 200) return;
				this.doubaoList = data.result.data;
				this.total = data.result.total;
			},
			async getAiApplicationHistoryList() {
				let postData = {
					page_size: this.page_size1,
					page_index: this.page_index1,
					user_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getAiApplicationHistoryList(postData);
				if (status !== 200) return;
				this.hisLists = data.result.data;
				this.total1 = data.result.total;
			},
			goBack() {
				this.$router.go(-1)
			},
			async _getUserListDetail(uuid) {
				const {
					data,
					status
				} = await getUser({
					uuid: uuid
				});
				if (status === 200) {
					this.detailObject = data.result;
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},
			async disableUser() {
				let postData = {
					user_id: this.detailObject.user_id
				}
				const {
					status,
					data
				} = await disableUser(postData);
				if (status !== 200) return;
				await this._getUserListDetail(this.detailObject.user_id);
			},

			async ableUser() {
				let postData = {
					user_id: this.detailObject.user_id
				}
				const {
					status,
					data
				} = await ableUser(postData);
				if (status !== 200) return;
				await this._getUserListDetail(this.detailObject.user_id);
			},

		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}
	.operation-item{
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}
</style>